var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{staticClass:"z-index-5",attrs:{"disable-resize-watcher":"","app":"","clipped":"","right":"","width":_vm.modifyMode.width},model:{value:(_vm.modifyMode.show),callback:function ($$v) {_vm.$set(_vm.modifyMode, "show", $$v)},expression:"modifyMode.show"}},[_c(_vm.pageName,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }